import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import {
    Button,
    Form,
    Field,
    Switch,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Stepper,
    Rate,
    Uploader,
    Popup,
    Picker,
    Tab,
    Tabs,
    DatetimePicker,
    Cascader,
    TreeSelect,
    Icon,
    Loading,
    Swipe,
    SwipeItem,
    Dialog
} from 'vant'
import 'vant/lib/index.css'

[
    Button,
    Form,
    Field,
    Switch,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Stepper,
    Tab,
    Tabs,
    Rate,
    Uploader,
    Popup,
    Picker,
    DatetimePicker,
    Cascader,
    TreeSelect,
    Icon,
    Loading,
    Swipe,
    SwipeItem,
    Dialog
].forEach((item) => Vue.use(item))

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
